module.exports = __webpack_public_path__ + "media/airbnb-logo.f8c276322b8d85b260b795c451ba3f44.svg";